export default function () {

  var ua = navigator.userAgent.toLowerCase();

  //console.log(ua);
  var appName = navigator.appName.toLowerCase();

  var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");

  var iOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream

  var isIeMobile = ua.indexOf("iemobile") > -1;

  var isMStouch = ua.indexOf("touch") > -1 && ua.indexOf("trident") > -1;

  var traceDiv =  document.getElementById("trace");

  var isGoogleChrome = ua.indexOf("chrome") > -1;

  var isFirefox = ua.indexOf("firefox") > -1;

  var isSafari = ua.indexOf("safari") > -1;


  var IEVersion = detectIE();

  var classStr = "";

  if(IEVersion != null){	
  	classStr += " browser-ie-" + IEVersion;
    classStr += " browser-ie";
  }

  if(iOS){	
  	classStr += " platform-ios";
  }
  if(isAndroid){	
  	classStr += " platform-android";
  }

  if(isIeMobile){	
  	classStr += " platform-iemobile";
  }

  if(isMStouch){	
  	classStr += " platform-iesurface";
  }

  if(isGoogleChrome){	
    isSafari = false;
  	classStr += " browser-chrome";
  }

  if(isFirefox){	
  	classStr += " browser-firefox";
  }
  if(isSafari && !iOS){
    classStr += " browser-mac-safari";  
  }

  if (isSafari && iOS) {
    classStr += " browser-ios-safari";  
  }

  document.documentElement.className += classStr;



  function detectIE() {
    var ua = window.navigator.userAgent;


    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
    
    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
    
    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
    
    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      var rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return null;
  }


}



// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/platform.js